import { ReactNode } from 'react';
import { Navbar, Nav, Container, Button, Badge } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/common/hooks/use-auth';

export default function Layout({ children }: { children: ReactNode }) {
  const { actor, authEnabled, logout } = useAuth();
  const loc = useLocation();
  const active = (p: string) => (loc.pathname === p || loc.pathname.startsWith(p + '/') ? 'fw-bold' : '');

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="md">
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            vuln-sentinel
            {!authEnabled && (
              <Badge bg="warning" text="dark" className="ms-2">
                local (no auth)
              </Badge>
            )}
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse>
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/repos" className={active('/repos')}>Repos</Nav.Link>
              <Nav.Link as={Link} to="/onboarding" className={active('/onboarding')}>Onboard</Nav.Link>
              <Nav.Link as={Link} to="/prs" className={active('/prs')}>PRs</Nav.Link>
              <Nav.Link as={Link} to="/exceptions" className={active('/exceptions')}>Exceptions</Nav.Link>
              <Nav.Link as={Link} to="/audit" className={active('/audit')}>Activity</Nav.Link>
            </Nav>
            <Nav>
              <Navbar.Text className="me-3">{actor}</Navbar.Text>
              {authEnabled && (
                <Button variant="outline-light" size="sm" onClick={logout}>
                  Sign out
                </Button>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container fluid className="py-4">
        {children}
      </Container>
    </>
  );
}
